import React from "react";
import "./news-skeleton.css";

const range = (n) => Array.from({ length: n }, (_, i) => i);

const NewsSkeletonGrid = ({ count = 16 }) => {
  return (
    <div className="news-grid">
      {range(count).map((i) => (
        <article key={i} className="news-item" aria-hidden="true">
          <div className="skeleton skeleton-thumb" />
          <div className="skeleton skeleton-title" />
        </article>
      ))}
    </div>
  );
};

export default NewsSkeletonGrid;